import { ArrowRight } from 'assets/icons';
import { useNavigate } from 'react-router-dom';
import { useArticles } from 'apis/query';
import { Spin } from 'antd';
import { LoadingOutlined } from '@ant-design/icons';
import styles from './Other.module.css';

const itemsPerPage = 4;

export default function Others({ category = 'blog', title = 'Lorem Ipsum' }) {
  const navigate = useNavigate();
  const {
    items = [],
    isLoading,
    hasNextPage,
    fetchNextPage,
  } = useArticles({
    limit: itemsPerPage,
    type: 'other',
    category,
  });

  return (
    <div className={styles.container}>
      <div className={styles.highlight} />
      <div className={styles.title}>{title}</div>
      <Spin
        spinning={isLoading}
        indicator={<LoadingOutlined spin />}
        size="large"
      >
        <div className={styles.grid}>
          {items?.length ? (
            items?.map((item, index) => (
              <div key={index} className={styles.item}>
                <img
                  loading="lazy"
                  alt={`news-${item.image}`}
                  src={item.image}
                  className={styles.image}
                />
                <div className={styles.textContainer}>
                  <div className={`two-lines ${styles.itemTitle}`}>
                    {item.title}
                  </div>
                  {(item.author || item.date) && (
                    <div className={styles.itemMeta}>
                      <b>{item.author}</b> · {item.date}
                    </div>
                  )}
                  <div className={`three-lines ${styles.itemDescription}`}>
                    {item.description}
                  </div>
                  <div className={styles.readMoreContainer}>
                    <button
                      onClick={() =>
                        navigate(`/${category}/detail/${item?.slug}`, {
                          state: { data: item },
                        })
                      }
                      className={styles.button}
                    >
                      Read More <ArrowRight fill="#fff" />
                    </button>
                  </div>
                </div>
              </div>
            ))
          ) : (
            <div>Belum ada artikel.</div>
          )}
        </div>

        {hasNextPage && (
          <div className={styles.loadMoreContainer}>
            <button
              onClick={() => fetchNextPage()}
              className={styles.loadMoreButton}
            >
              Load More
            </button>
          </div>
        )}
      </Spin>
    </div>
  );
}
